module.exports = "files/favicon.png";